import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { APPLINKS } from '../AppConst'

/**
 * Renders a Component if user has logged in. 
 * @argument path , component
 */
const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => (
            sessionStorage.getItem('user') ?
                (<Component {...props} />) :
                (<Redirect to={APPLINKS.login} />)
        )} />
    )
}

export default PrivateRoute
